import { createFileRoute } from "@tanstack/react-router";
import HowMuchDoesTaxResolutionCost from "@/pages/site/HowMuchDoesTaxResolutionCost";

export const Route = createFileRoute("/resources/how-much-does-tax-resolution-cost")({
  component: () => <HowMuchDoesTaxResolutionCost />,
});
